export const DELETE_SPOT_LIST_FAILURE = 'DELETE_SPOT_LIST_FAILURE';

export const deleteSpotListFailure = (payload: Error) => ({
    type: DELETE_SPOT_LIST_FAILURE,
    payload,
    error: true,
});
